import { useEffect, useMemo } from "react";
import classes from "./Report.module.css";
import BoxWrapper from "../../../../../components/ui/boxWrapper";

function MissingInGSTR({ missingGstr, onTabClick, loading }) {
  useEffect(() => {
    onTabClick();
  }, [onTabClick]);

  const rows = useMemo(() => {
    if (loading) {
      return (
        <tr>
          <td colSpan={11} className={classes.loader}>
            Loading...
          </td>
        </tr>
      );
    }
    const missingGstrData = missingGstr?.record?.missingInGstr ?? [];

    if (!missingGstrData.length) {
      return (
        <tr>
          <td colSpan={17} className={classes.noData}>
            No Data Found!
          </td>
        </tr>
      );
    }

    return missingGstrData.map((invoice, index) => (
      <tr key={index}>
        <td style={{ color: "black" }}>{invoice.GSTIN}</td>
        <td style={{ color: "black" }}>{invoice.Vendor_Name}</td>
        <td style={{ color: "black" }}>{invoice.DOC_NUMBER}</td>
        <td style={{ color: "black" }}>{invoice.DOC_DATE}</td>
        <td style={{ color: "black" }}>{invoice.DOC_TYPE}</td>
        <td style={{ color: "black" }}>
          {Number(invoice.Taxable_Value).toFixed(2)}
        </td>
        <td style={{ color: "black" }}>{Number(invoice.CGST).toFixed(2)}</td>
        <td style={{ color: "black" }}>{Number(invoice.SGST).toFixed(2)}</td>
        <td style={{ color: "black" }}>{Number(invoice.IGST).toFixed(2)}</td>
        <td style={{ color: "black" }}>{Number(invoice.Cess).toFixed(2)}</td>
        <td style={{ color: "black" }}>
          {Number(invoice.Total_Amount).toFixed(2)}
        </td>
      </tr>
    ));
  }, [loading, missingGstr?.record?.missingInGstr]);

  return (
    <>
      <BoxWrapper
        searchInputPlaceholder="Search..."
        boxTitle="Reconciliation Status:  Invoice(s) Missing in GSTR-6A"
      >
        <div className={classes.ResponsiveTable}>
          <table className={classes.missingInAccountTableCss}>
            <thead>
              <tr>
                <th rowSpan={2}>GSTIN</th>
                <th rowSpan={2} align="right">
                  VENDOR NAME
                </th>
                <th rowSpan={2} align="right">
                  DOC NUMBER
                </th>
                <th rowSpan={2} align="right">
                  DOC DATE
                </th>
                <th rowSpan={2} align="right">
                  DOC TYPE
                </th>
                <th
                  style={{ background: "#ffcc66" }}
                  colSpan={6}
                  align="center"
                >
                  As per Books
                </th>
              </tr>
              <tr>
                <th style={{ background: "#ffcc66" }} align="right">
                  TAXABLE VALUE
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  SGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  IGST
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  CESS
                </th>
                <th style={{ background: "#ffcc66" }} align="right">
                  TOTAL AMOUNT
                </th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}

export default MissingInGSTR;
